export default "__VITE_ASSET__BIk6Xn7o__"